<template>
  <row class="file-row">
    <template v-slot:prefix>
      <i
        v-if="!['word', 'excel', 'ppt', 'pdf'].includes(getType(file.type))"
        class="el-icon-document"
      ></i>
      <svg-icon
        v-else
        :icon-class="getType(file.type)"
        style="font-size: 20px;margin-left: -2px"
      ></svg-icon>
    </template>
    <el-input
      v-if="enableEdit"
      ref="editInput"
      v-model="fileName"
      placeholder="请输入文件名"
      size="small"
      @blur="editInputBlur"
      @keyup.native.enter="editInputBlur"
    ></el-input>
    <div :title="file.name" v-else>{{ file.name }}</div>
    <template v-slot:suffix>
      <template v-if="file.uploading">
        <i class="el-icon-loading"></i>
      </template>
      <template v-else>
        <span class="size-info">{{ file.sizeStr }}</span>
        <span class="operation">
          <!--<i class="el-icon-edit" @click="showEditInput"></i>-->
          <i class="el-icon-error" @click.stop="$emit('delete')"></i>
        </span>
      </template>
    </template>
  </row>
</template>

<script>
import Row from "@/components/BaseComponents/Panel/Row"
import { resolveFileName, getFileType } from "@/utils/common"

export default {
  name: "file-row",
  components: {
    Row
  },
  props: {
    file: Object
  },
  data() {
    return {
      fileName: "",
      ext: "",
      enableEdit: false
    }
  },
  methods: {
    getType: getFileType,
    showEditInput() {
      if (!this.enableEdit) {
        this.enableEdit = true
        let { name, ext } = resolveFileName(this.file.name)
        this.ext = ext
        this.fileName = name
        this.$nextTick(() => this.$refs.editInput.focus())
      } else this.editInputBlur()
    },
    editInputBlur() {
      this.enableEdit = false
      this.file.name = this.ext ? this.fileName + "." + this.ext : this.fileName
    }
  }
}
</script>

<style lang="scss" scoped>
.file-row {
  text-align: left;
  height: 32px;
  line-height: 32px;
  cursor: default;
  &:hover {
    background-color: $color-bg-select;
    ::v-deep .prefix {
      color: inherit;
    }
    .size-info {
      display: none;
    }
    .operation {
      display: block;
      cursor: pointer;
      i {
        padding: 3px;
      }
    }
  }
  ::v-deep .el-input--small .el-input__inner {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    padding: 0 8px;
  }
  .operation {
    display: none;
  }
  &.row {
    margin-bottom: 0;
    color: #303133;
    ::v-deep {
      .suffix {
        visibility: visible;
        font-weight: normal;
        &:hover {
          color: unset;
          cursor: default;
        }
        .el-icon-error:hover {
          color: red;
        }
      }
    }
  }
}
</style>
